import { useState } from "react";
import { api, setToken } from "../api";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore]     = useState(null);
  const [loading, setLoading]   = useState(false);

  const submit = async () => {
    if (!email || !password) return;
    setLoading(true); setErrore(null);
    try {
      const data = await api.login(email, password);
      setToken(data.token);
      login(data.token, data.utente, !!data.cambio_password_obbligatorio);
    } catch (e) {
      setErrore(e.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">📄</div>
        <h1 className="login-title">Preventivi ISP</h1>
        <p className="login-sub">Accedi per continuare</p>
        {errore && <div className="errore-box" style={{ marginBottom: 16 }}>⚠️ {errore}</div>}
        <div className="form-group" style={{ marginBottom: 14 }}>
          <label className="form-label">Email</label>
          <input className="form-input" type="email" value={email}
            onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
            placeholder="utente@isp.local" autoFocus />
        </div>
        <div className="form-group" style={{ marginBottom: 20 }}>
          <label className="form-label">Password</label>
          <input className="form-input" type="password" value={password}
            onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
            placeholder="••••••••" />
        </div>
        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
          onClick={submit} disabled={loading || !email || !password}>
          {loading ? "Accesso in corso..." : "Accedi"}
        </button>
        <p className="login-hint">Al primo accesso: admin@isp.local / admin123</p>
      </div>
    </div>
  );
}
